module.exports = __webpack_public_path__ + "img/femaleAvatar.89e40ef5.png";